export const SUPPORTERS_RESULT_SIZE = 2;
